import React from 'react';
import { useField } from 'formik';
export default function DestinationField({ name }) {
    const [field] = useField(name);
    return (
        <div className="flex-1 w-full p-4 px-6 border-1 lg:border-r border-gray-200 border rounded-full lg:rounded-r-none lg:rounded-l-full ">
            <input
                type="text"
                placeholder="z.B. Reiseziel oder Hotelname"
                className="w-full outline-none text-gray-700 "
                {...field}
            />
        </div>
    );
}
